import React from "react";
import PropTypes from "prop-types";

/**
 * Decorative background concentric rings for the referral hero banner.
 */
export const ReferralBannerDecorativeRings = ({
  className = "tw-w-full tw-h-full",
}) => (
  <svg
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <circle cx="280" cy="200" r="160" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="280" cy="200" r="110" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="280" cy="200" r="60" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="210" cy="200" r="3.5" fill="currentColor" />
  </svg>
);

ReferralBannerDecorativeRings.propTypes = {
  className: PropTypes.string,
};

ReferralBannerDecorativeRings.defaultProps = {
  className: "tw-w-full tw-h-full",
};

/**
 * Downward arrow icon used in the primary CTA button.
 */
export const ArrowDownIcon = ({
  className = "tw-w-4 tw-h-4",
  strokeWidth = 1.75,
}) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M8 3.33331V12.6666M8 12.6666L12.6667 7.99998M8 12.6666L3.33333 7.99998"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ArrowDownIcon.propTypes = {
  className: PropTypes.string,
  strokeWidth: PropTypes.number,
};

ArrowDownIcon.defaultProps = {
  className: "tw-w-4 tw-h-4",
  strokeWidth: 1.75,
};
